/**
 * Lightweight cart utility — persisted in localStorage.
 * Keyed per-store so users can shop multiple stores in parallel.
 */
const KEY = "arab_sanad_cart_v1";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
};
const write = (data) => localStorage.setItem(KEY, JSON.stringify(data));

export const cart = {
  get(storeId) {
    const all = read();
    return all[storeId] || [];
  },
  add(storeId, product, qty = 1) {
    const all = read();
    const items = all[storeId] || [];
    const existing = items.find((i) => i.product_id === product.product_id);
    if (existing) {
      existing.quantity += qty;
    } else {
      items.push({
        product_id: product.product_id,
        name: product.name,
        name_ar: product.name_ar,
        unit: product.unit,
        price: product.price,
        image: product.images?.[0],
        quantity: qty
      });
    }
    all[storeId] = items;
    write(all);
    return items;
  },
  updateQty(storeId, productId, qty) {
    const all = read();
    const items = all[storeId] || [];
    const it = items.find((i) => i.product_id === productId);
    if (it) {
      it.quantity = qty;
      if (qty <= 0) all[storeId] = items.filter((i) => i.product_id !== productId);
      else all[storeId] = items;
      write(all);
    }
    return all[storeId] || [];
  },
  remove(storeId, productId) {
    const all = read();
    all[storeId] = (all[storeId] || []).filter((i) => i.product_id !== productId);
    write(all);
    return all[storeId];
  },
  clear(storeId) {
    const all = read();
    delete all[storeId];
    write(all);
  },
  count(storeId) {
    return this.get(storeId).reduce((s, i) => s + i.quantity, 0);
  },
  subtotal(storeId) {
    return this.get(storeId).reduce((s, i) => s + (i.price || 0) * i.quantity, 0);
  }
};
